import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ColumnSettings } from '../../common/models';

@Component({
    selector: 'multi-select-viewer',
    templateUrl: './multi-select-viewer.component.html',
    styleUrl: './multi-select-viewer.component.scss',
})
export class MultiSelectViewerComponent implements OnChanges {
  @Input('record') record: any;
  @Input('column') column!: ColumnSettings;

  public options: any[] = [];
  public optionLabelName: string = '';
  public selectedOptions: any[] = [];

  public displayText: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['record'] || changes['column']) {
      if (!this.column.multiSelectSettings) {
        throw 'this.column.multiSelectSettings cannot be null';
      }

      // consider data as not loaded yet
      if (!this.column.multiSelectSettings.data) {
        return;
      }

      // option value
      let optionValue = this.record[this.column.field];
      if (!optionValue) {
        return;
      }

      if (typeof this.column.multiSelectSettings.data === typeof []) {
        let values = this.column.multiSelectSettings.data as any[];
        if (values.length === 0) {
          return;
        }
      }

      this.optionLabelName = this.column.multiSelectSettings.textField;
      this.options = this.column.multiSelectSettings.data as any[];
      this.selectedOptions = this.options.filter(o => this.record[this.column.field].includes(o[this.column.multiSelectSettings!.valueField]));

      if (this.selectedOptions) {
        this.displayText = this.selectedOptions.map(opt => opt[this.column.multiSelectSettings!.textField]).join(", ");
      }
    }
  }
}
